<div class="image-container">
  @if (imageUrl) {
  <img [src]="imageUrl" [alt]="'common.preview' | translate" />
  } @else {
  <div class="placeholder">
    <ion-icon name="image-outline"></ion-icon>
  </div>
  }
</div>
